import * as DL from './../DL/Dinosaur';

/**
 * BUSINESS LOGIC (BL): DINOSAUR
 */

export const GetThemes = async () => {
    return await DL.GetThemes();
};

export const GetTheme = async (id) => {
    return await DL.GetTheme(id);
};

export const SaveTheme = async (data) => {
    if (!data.name || data.name.trim() === '') {
        return { success: false, message: 'El nombre del tema es obligatorio.' };
    }
    return await DL.SaveTheme(data);
};

export const DeleteTheme = async (id) => {
    return await DL.DeleteTheme(id);
};

export const GetConfig = async (targetScreenId) => {
    return await DL.GetConfig(targetScreenId);
};

export const SaveConfig = async (data) => {
    return await DL.SaveConfig(data);
};

export const PrepareScreen = async (screenId) => {
    return await DL.PrepareScreen(screenId);
};

export const ProyectarScreen = async (screenId) => {
    return await DL.ProyectarScreen(screenId);
};

export const StartGame = async (screenId) => {
    return await DL.StartGame(screenId);
};

export const UploadMedia = async (file, type) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    return await DL.UploadMedia(formData);
};

export const GetHistory = async (screenId) => {
    return await DL.GetHistory(screenId);
};

export const StopGame = async (screenId) => {
    return await DL.StopGame(screenId);
};

export const ResetGame = async (screenId) => {
    return await DL.ResetGame(screenId);
};

export const Jump = async (screenId, playerName = 'Admin') => {
    return await DL.Jump(screenId, playerName);
};
